import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Header.scss';
import { useNavigate } from 'react-router-dom';
import MainURL from '../MainURL';
import logoPng from '../images/logo.png';

const Header: React.FC = () => {

  let navigate = useNavigate();

  const menus = [
    {
      title: "서비스소개",
      url: "/service/member",
      links: [
        { title: "성도 앱", subUrl: "/service/member" },
        { title: "앱관리 앱", subUrl: "/service/admin" },
        { title: "교적부 앱", subUrl: "/service/roll" },
        { title: "재정 앱", subUrl: "/service/finance" },
        { title: "주일학교 앱", subUrl: "/service/sundayschool" },
      ],
    },
    // { title: "샘플", url:"/sample", 
    //   links: [
    //     {title:"앱 샘플", subUrl:"/sample"}, 
    //   ]
    // },
    { title: "요금", url:"/price", 
      links: [
        {title:"요금", subUrl:"/price"}, 
      ]
    },
    { title: "서비스신청", url:"/inquiry",
      links: [
        {title:"신청", subUrl:"/inquiry"},
        {title:"개발자계정등록안내", subUrl:"/developer-account-guide"},
        {title:"시안 확인", subUrl:"/mvp-confirm"},
        {title:"계약", subUrl:"/contract"},
        {title:"결제", subUrl:"/payment"},
      ]
    },
    { title: "교회앱모아", url:"/company",
      links: [
        {title:"소개", subUrl:"/company"}, 
        {title:"공지사항", subUrl:"/company/notice"},
        {title:"자주 묻는 질문", subUrl:"/company/faq"}
      ]
    },
  ];

  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState<{ [key: number]: boolean }>({});

  const toggleMenu = () => {
      setMenuOpen(!menuOpen);
  };

  // 메뉴(수련회/서비스 등) 클릭수 카운트
  const countMenuClick = (type?: string) => {
    if (!type) return;
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const date = `${yyyy}-${mm}-${dd}`;
    axios.post(`${MainURL}/admin/countup`, { date, type }).catch(() => {});
  };

  const toggleMobileMenu = (index: number) => {
      setMobileMenuOpen((prevState) => ({
          ...prevState,
          [index]: !prevState[index],
      }));
  };
  const handleRecruitSubMenuClick = (subUrl: string, countType?: string) => {
    countMenuClick(countType);
    const [pathname, hash] = subUrl.split('#');
    if (hash) {
      navigate({ pathname, hash });
    } else {
      navigate(subUrl);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      /** 모바일 메뉴가 열려있을 때는 페이지 스크롤로 닫히지 않도록 가드 */
      if (menuOpen) return;
      if (window.scrollY > 10 && window.scrollY < 100) {
        setMenuOpen(false);
      } 
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuOpen]);

  /**
   * 모바일 햄버거 메뉴 오픈 동안 배경(페이지) 스크롤 차단.
   * `overflow: hidden`만으로는 iOS Safari 등에서 체인 스크롤이 남는 경우가 있어
   * 스크롤 위치를 유지한 채 `body`를 fixed로 고정한다.
   */
  useEffect(() => {
    if (!menuOpen) return;

    const scrollY = window.scrollY;
    const prev = {
      bodyOverflow: document.body.style.overflow,
      bodyPosition: document.body.style.position,
      bodyTop: document.body.style.top,
      bodyLeft: document.body.style.left,
      bodyRight: document.body.style.right,
      bodyWidth: document.body.style.width,
      bodyOverscroll: document.body.style.overscrollBehavior,
      htmlOverflow: document.documentElement.style.overflow,
      htmlHeight: document.documentElement.style.height,
      htmlOverscroll: document.documentElement.style.overscrollBehavior,
    };

    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100%';
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overscrollBehavior = 'none';

    return () => {
      document.body.style.overflow = prev.bodyOverflow;
      document.body.style.position = prev.bodyPosition;
      document.body.style.top = prev.bodyTop;
      document.body.style.left = prev.bodyLeft;
      document.body.style.right = prev.bodyRight;
      document.body.style.width = prev.bodyWidth;
      document.body.style.overscrollBehavior = prev.bodyOverscroll;
      document.documentElement.style.overflow = prev.htmlOverflow;
      document.documentElement.style.height = prev.htmlHeight;
      document.documentElement.style.overscrollBehavior = prev.htmlOverscroll;
      window.scrollTo(0, scrollY);
    };
  }, [menuOpen]);


  return (
    <div className="header">
      <div className="header-top">
        <div className="inner">
          <div className="container header-top-container">
            <div className="header-button_wrap">
              <div className="header-button"
                onClick={()=>{navigate('/manage-app/');}}
              >교회앱관리</div>
              <div className="header-button"
                onClick={()=>{navigate('/manage-roll');}}
              >교적관리</div>
              <div className="header-button"
                onClick={()=>{navigate('/manage-finance');}}
              >재정관리</div>
              <div className="header-button"
                onClick={()=>{navigate('/manage-ss/');}}
              >주일학교앱관리</div>
            </div>
          </div>
        </div>
      </div>
      <div className="header-content">
        <div className="inner">
          <div className="container header-content-container">
              <div className="header-logo" 
                onClick={()=>{navigate('/')}}
              >
                <img src={logoPng} alt="교회앱모아" className="header-logo__mark" />
                <h1>교회앱모아</h1>
              </div>
              <div className="header-menu">
                {
                  menus.map((item:any, index:any) => (
                    <div className="menu-item" key={index}>
                        <div className="menu-face" 
                          onClick={()=>{
                            countMenuClick(item.countType);
                            navigate(item.url);
                          }}
                        >{item.title}</div>
                        <div className="menu-body">
                          { 
                            item.links.map((subItem:any, subIndex:any) => (
                              <div className="menu-part" key={subIndex}>
                                <div onClick={()=>{
                                    handleRecruitSubMenuClick(subItem.subUrl, item.countType);
                                  }}>{subItem.title}</div>
                              </div>
                            ))
                          }
                        </div>
                    </div>
                  ))
                }
              </div>
              <div className={`header-hamburger_menu ${menuOpen ? 'header-hamburger_menu--open' : ''}`}>
                  <div className="header-hamburger_icon" onClick={toggleMenu}></div>
                  <div className="header-mobile_menu">
                      <div className="mobile_menu-inner">
                          <div className="mobile_menu-top">
                            <div className="mobile_menu-button_wrap">
                                <div className="header-button" onClick={()=>{
                                  navigate("/manage-app/"); toggleMenu();
                                }}>교회앱관리</div>
                                <div className="header-button" onClick={()=>{
                                  navigate("/manage-roll"); toggleMenu();
                                }}>교적관리</div>
                                <div className="header-button" onClick={()=>{
                                  navigate("/manage-finance"); toggleMenu();
                                }}>재정관리</div>
                                <div className="header-button" onClick={()=>{
                                  navigate("/manage-ss/"); toggleMenu();
                                }}>주일학교앱관리</div>
                            </div>
                          </div>

                          <div className="mobile_menu-list">
                              {
                                menus.map((item:any, index:any) => (
                                  <div className={`mobile_menu-item ${mobileMenuOpen[index] ? 'mobile_menu-item--open' : ''}`} 
                                    key={index} onClick={() => 
                                      toggleMobileMenu(index)
                                    }>
                                      <div className="mobile_menu-item_inner">
                                          <div className={`mobile_menu-face ${mobileMenuOpen[index] ? 'mobile_menu-face--open' : ''}`}>
                                              <div className="mobile_menu-face_text" 
                                                onClick={()=>{
                                                  countMenuClick(item.countType);
                                                  navigate(item.url);
                                                  toggleMenu();
                                                }}>{item.title}</div>
                                              <div className="mobile_menu-face_icon"></div>
                                          </div>
                                          <div className="mobile_menu-body">
                                              {
                                                item.links.map((subItem:any, subIndex:any) => (
                                                  <div className="mobile_menu-part"
                                                    onClick={()=>{
                                                      handleRecruitSubMenuClick(subItem.subUrl, item.countType);
                                                      toggleMenu();
                                                    }} key={subIndex}
                                                  >
                                                    {subItem.title}
                                                  </div>
                                              ))}
                                          </div>
                                      </div>
                                  </div>
                              ))}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
